import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    formBoxWrap: {
      width: '100%',
      marginRight: 23,
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        marginRight: 0,
      },
    },
    cardForm: {
      borderRadius: 8,
      [theme.breakpoints.down(Sizes.mobile)]: {
        padding: 0,
        margin: 0,
      },
    },
    label: {
      fontSize: 12,
      marginBottom: 8,
      display: 'flex',
      marginTop: 5,
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
      },
    },
    baseClass: {
      width: '100%',
      flexShrink: 0,
      border: `1px solid ${colorVariables.steelGrey}`,
      borderRadius: 6,
      padding: '13px 10px',
      backgroundColor: colorVariables.white,
      '&:hover': {
        border: `1px solid ${colorVariables.blue}`,
      },
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '100%',
        backgroundColor: colorVariables.white,
      },
    },
    baseClassExp: {
      width: '100%',
    },
    baseClassCvc: {
      width: '100%',
    },
    focus: {
      border: `1px solid ${colorVariables.blue}`,
    },
    invalid: {
      border: `1px solid ${colorVariables.red}`,
      '&:hover': {
        border: `1px solid ${colorVariables.red}`,
      },
    },
    fieldWrap: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 12,
    },
    smallField: {
      width: '48%',
      [theme.breakpoints.down(Sizes.mobile)]: {
        width: '48%',
      },
    },
    actionContainer: {
      marginTop: 20,
      textAlign: 'center',
    }
  }),
);
